module.exports = __webpack_public_path__ + "static/media/logo.386675c4.png";